<template>
  <div style="min-height: calc(100vh - 11em) !important">
    <div class="alert alert-success text-left" role="alert" v-if="getUpdateSuccessMsg">
      <span>Update to the integration has been applied</span>
    </div>
    <div class="alert alert-success text-left" role="alert" v-if="getAddSuccessMsg">
      <span>The carrier has been added successfully</span>
    </div>
    <!--Page Header-->
    <div class="row no-gutters mb-3 head-container">
      <div class="col-12 col-md-6 display-1">{{ carrierName }}</div>
      <div class="col-12 col-md-6 mt-sm-2 mt-md-0 text-sm-left text-md-right">
        <!-- TODO: Use permission string for updating carrier -->
        <router-link :to="{ name: 'carrier-manager' }" tag="button" tabindex="1" class="btn btn-outline-secondary" v-if="tabIndex==1">Cancel</router-link>
        <button type="button" class="btn btn-outline-success" tabindex="1" @click="saveCarrier(tabIndex)" v-if="tabIndex==1">Save Changes</button>
        <button type="button" class="btn btn-outline-success" :disabled="disabled" @click="openAdd()" v-if="tabIndex==0">+Add New Integration</button>
      </div>
    </div>

    <div>
    <b-tabs v-model="tabIndex" content-class="mt-3">
        <b-tab title="Carrier Integration" lazy active>
          <state-integration ref="stateIntegration"></state-integration>
        </b-tab>
        <b-tab title="Agency Integrations" lazy>
          <agency-integration ref="agencyIntegration"></agency-integration>
        </b-tab>
    </b-tabs>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import StateIntegration from './stateIntegration/StateIntegration';
import AgencyIntegration from './agencyIntegration/AgencyIntegration';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  components: {
    StateIntegration,
    AgencyIntegration,
  },
  data() {
    return {
      carrierProductFilters: [],
      tabIndex: 0,
    };
  },
  computed: {
    carrierName() {
      const carrier = this.$store.getters.carrier;
      return (carrier && carrier.carrierName ? carrier.carrierName : 'Carrier');
    },
    disabled(){
      if((this.$store.getters.getAddStatus && this.$store.getters.getAddStatus) || (this.$store.getters.getEditStatus && this.$store.getters.getEditStatus) || (this.$store.getters.getDisabledStatus && this.$store.getters.getDisabledStatus)){
        return true;
      }else{
        return false;
      }
    },
    getUpdateSuccessMsg() {
      return this.$store.state.commonState.showUpdateSuccess;
    },
    getAddSuccessMsg() {
      return this.$store.state.commonState.showAddSuccess;
    },
  },
  mounted() {
    this.$store.commit('setAddStatus', false);
    this.$store.commit('setEditStatus', false);
    this.$store.commit('setDisabledStatus', false);
  },
  methods: {
    openAdd(){
      this.$store.commit('setAddStatus', true);
    },
    saveCarrier(tabToSave) {
      switch (tabToSave) {
        case 0:
          this.$refs.stateIntegration.saveCarrier();
          break;

        case 1:
          this.$refs.agencyIntegration.saveCarrier();
          break;

        default:
          break;
      }
    },
    /**
     *  focus shift to cancel button from last field on form
     */
    checkTabSequence(e) {
      if(e.keyCode == 9) {
        if(e.preventDefault) {
            e.preventDefault();
        }
        document.getElementById('edit-agency-cancel').focus();
        return false;
      }
    },
  },
  watch: {
    tabIndex: function tabIndex(newValue, oldValue) {
      this.saveCarrier(oldValue); // Save the tab that is currently visible before switching to the new tab
      this.$store.commit('setAddStatus', false);
      this.$store.commit('setEditStatus', false);
      this.$store.commit('setDisabledStatus', false);
    },
  },
};
</script>
<style scoped>
/**PAGE HEADER STYLING**/
.btn-outline-secondary {
  color: #595959 !important;
  border-color: #595959 !important;
}
.btn-outline-secondary:hover {
  color: #fff !important;
  border-color: #595959;
  background-color: #595959;
}
.btn-outline-secondary:focus {
  box-shadow: 0 0 0.2rem rgba(51, 51, 51, .45);
  -webkit-box-shadow: 0 0 0.2rem rgba(51, 51, 51, .45);
}

/**TAB PANE STYLING**/
.tab-content .tab-pane{
  padding: 0;
  outline: none;
}

/**COLUMN STYLING**/
.col-head {
  background-color: #3674B2;
}

/**FORM STYLING**/
/**Full Width: form-groups**/
form .form-group.w-full{
  width: 100%;
}

/**Extra large devices (large desktops, 1200px and up)**/
@media (min-width: 1200px) {
  form .form-group{
    width: 50%;
  }
}

/**Large devices (desktops, 992px and up)**/
@media (max-width: 992px) {
  form .form-group{
    width: 100%;
  }
}

/**Medium devices (tablets, 768px and up)**/
@media (max-width: 768px) {
  form .form-group{
    width: 100%;
  }
}
/**Small devices (landscape phones, 576px and up)**/
@media (max-width: 576px) {
  form .form-group{
    width: 100%;
  }
}
/**FIELD LABEL STYLING**/
label {
  margin-bottom: 0.25rem;
}
/**Side-by-Side fields**/
form .form-group.float-left {
  width: auto !important;
}
#no-carriers-message {
  display: flex;
  height:300px;
  justify-content: center;
  align-items: center;
  font-size:2rem;
}
.btn-outline-success:disabled{
  color: #ffffff !important;
  background-color: rgba(0, 0, 0, 0.12) !important;
  border-color: #EDEDED !important;
  pointer-events: none;
}
</style>
<style>
/**TAB NAV STYLING**/
.nav-tabs{
  border-bottom: 2px solid #003366;
}
.nav-tabs .nav-link{
  color: #003366;
}
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{
  color: #FFFFFF;
  background-color: #003366;
  border-color: #003366;
}
.nav-tabs .nav-link:hover{
  border-color: #003366;
}
.nav-tabs .nav-link.active{
  background-color: #003366 !important;
  border-color: #003366 !important;
}
.nav-tabs .nav-link.disabled{
  color: #CCCCCC;
  border: none;
}
.tab-content {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/carriers/EditCarrier.vue?5c7c948e